import IdeoDAges from "../../../../src/composants/accueil/ideo-d-ages";
import * as React from 'react';
export default {
  IdeoDAges,
  React
};